import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { DatePipe } from '@angular/common';
import { TblLeadMedium } from 'src/app/shared/models/leadMedium';
import { LeadMediumService } from 'src/app/shared/services/leadMedium.service';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditLeadMediumDialogComponent } from './edit-lead-medium-dialog.component';
import { LeadCampaignService } from 'src/app/shared/services/leadcampaign.services';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-medium',
  templateUrl: './lead-medium.component.html',
  styleUrls: ['./lead-medium.component.css']
})
export class LeadMediumComponent implements OnInit {
  model: TblLeadMedium;
  members: Observable<TblLeadMedium[]>;
  allItems: TblLeadMedium[] = [];
  pagedItems: TblLeadMedium[] = [];
  pager: any = {};
  userType: string;
  constructor(private _leadMediumService : LeadMediumService,
    private _leadCampaignService : LeadCampaignService,
    private _leadMediumervice:LeadMediumService,
    private dialog: MatDialog,
    private modalService: BsModalService,
    private localStorage:LocalStorageService,
    private spinnerService: AppComponent,
    private notifyService: NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblLeadMedium();
    this.getAllData();
  }
  getAllData(){
    this.members= this._leadMediumervice.getAllLeadMedium();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  openAddDialog() {
    const model = new TblLeadMedium();
    const dialogRef = this.dialog.open(EditLeadMediumDialogComponent, {
      width: '500px',
      data: { title: 'New Lead Medium', model: model, isEditing: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.create_edit_after_dialog(false);
      }
    });
  }

  openEditDialog(id: any) {
    this._leadMediumervice.getLeadMediumById(id).subscribe(resp => {
      const dialogRef = this.dialog.open(EditLeadMediumDialogComponent, {
        width: '500px',
        data: { title: 'Edit Lead Medium', model: resp, isEditing: true }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.model = result.model;
          this.create_edit_after_dialog(true);
        }
      });
    });
  }


  //Editing Data
  validateForm():boolean{
    
    if(!this.model.leadMediumName){
      this.notifyService.showError("Lead Medium Name can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }

  create_edit_after_dialog(isEditing: boolean){
    if(!this.validateForm()){
      return;
    }
    this._leadMediumervice.saveAndUpdateLeadMedium(this.model).subscribe(resp=>{
      if(resp.refNo>0){
        this.notifyService.showSuccess(isEditing ? "Updated Successfully!" : "Saved Successfully!", "Success");
        this.getAllData()
      }
      else{
        this.notifyService.showError(resp.message, "Error")
      }
    },(err) => {
      this.notifyService.showError(err, "Error")
    });
  }
  close_clicked()
  {
    this.getAllData();
  }
  deleteClick(id:any)
  {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'Lead Medium', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
